module.exports = __webpack_public_path__ + "media/images/icon-announce@3x-18aaf8c801a588915ea909007ba8b5ec.png";